import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";

const Columns = ({ permissions, onStatusChange, onEdit, onDelete, user }) => [
  {
    dataField: "key",
    text: "Key",
    formatter: (_, row) => <span className="text">{row.key}</span>,
  },
  {
    dataField: "used",
    text: "Used",
    formatter: (_, row) => (
      <Badge bg={row.isUsed ? "success" : "secondary"}>
        {row.isUsed ? "Yes" : "No"}
      </Badge>
    ),
  },
  {
    dataField: "adminEmail",
    text: "Admin Email",
    formatter: (_, row) => <span className="text">{row.adminDetails?.email || user?.email}</span>,
  },
  {
    dataField: "adminName",
    text: "Admin Name",
    formatter: (_, row) => <span className="text">{row.adminDetails?.name || user?.name}</span>,
  },
  {
    text: "Created At",
    dataField: "date_created_utc",
    formatter: (_, row) => row.createdAt && DATE_FORMAT(row.createdAt),
  },
  {
    dataField: "status",
    text: "Status",
    formatter: (_, row) => (
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          onStatusChange && onStatusChange(row);
        }}
      >
        <Badge bg={row.isActive ? "success" : "danger"}>
          {row.isActive ? "Active" : "Inactive"}
        </Badge>
      </Link>
    ),
  },
  {
    text: "Action",
    dataField: "action",
    formatter: (_, row) => (
      <>
        {permissions?.edit ? (
          <button
            className="fas fa-pen"
            style={{
              fontSize: "16px",
              backgroundColor: "#fff",
              border: "none",
              cursor: row.isUsed ? "not-allowed" : "pointer",
              opacity: row.isUsed ? 0.5 : 1,
            }}
            title={row.isUsed ? "This permission is in use" : "Edit"}
            disabled={row.isUsed}
            onClick={() => !row.isUsed && onEdit?.(row)}
          />
        ) : null}

        {permissions?.delete ? (
          <button
            className="fas fa-trash-alt"
            style={{
              backgroundColor: "#fff",
              border: "none",
              cursor: row.isUsed ? "not-allowed" : "pointer",
              opacity: row.isUsed ? 0.5 : 1,
            }}
            title={row.isUsed ? "This permission is in use" : "Delete"}
            disabled={row.isUsed}
            onClick={() => !row.isUsed && onDelete?.(row)}
          />
        ) : null}
      </>
    ),
  },
];
export default Columns;